export default "__VITE_ASSET__BNQ0QHFj__"